import { apiRequest } from 'utils/request'

export const getSearchedLineNote = ({ searchedString }) =>
  apiRequest(`line-notes/search?notes=${searchedString}`)
